"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Modal = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _basis = require("basis");

var s = _interopRequireWildcard(require("./Modal.styles"));

var _utils = require("./utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// @ts-ignore
var Modal = function Modal(props) {
  var onClose = props.onClose,
      children = props.children,
      style = props.style;
  var node = (0, _utils.usePortalElement)();
  (0, _utils.useScrollLock)();
  (0, _utils.useFocusLock)(node);

  if (!node) {
    return null;
  }

  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(s.ModalContainer, {
    "data-testid": "ModalContainer"
  }, /*#__PURE__*/_react.default.createElement(s.ModalBackdrop, {
    "data-testid": "ModalBackdrop",
    onClick: onClose
  }), /*#__PURE__*/_react.default.createElement(s.ModalWrapper, null, /*#__PURE__*/_react.default.createElement(s.Modal, {
    style: style,
    "data-testid": "Modal"
  }, /*#__PURE__*/_react.default.createElement(s.ModalClose, {
    "data-testid": "ModalClose",
    type: "button",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_basis.Icon, {
    name: "cross",
    color: "grey.t75"
  })), children))), node);
};

exports.Modal = Modal;
var _default = Modal;
exports.default = _default;